import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IProjeDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProjeDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GET_PROJE_DETAY: any[];
  GET_PROJE_DETAY_dummy: any[];
  GET_PROJE_BIRIM_DURUMLAR: any[];
  GET_PROJE_BIRIM_DURUMLAR_dummy: any[];
  GET_PROJE_ASAMALAR_DURUM: any[];
  GET_PROJE_ASAMALAR_DURUM_dummy: any[];
  GET_PROJE_ON_SUREC: any[];
  GET_PROJE_ON_SUREC_dummy: any[];
}

export class ProjeDetay_ScreenBase extends React.PureComponent<
  IProjeDetay_ScreenProps,
  any
> {
  projedetay_891482_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "44fa5bcf-c9c6-47c1-bee0-fc8bbb19945b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 547809, PropertyName: "value", Value: "·" },
        { Id: 471300, PropertyName: "value", Value: "·" },
        { Id: 114330, PropertyName: "value", Value: "- Proje Detayları" },
        { Id: 19253, PropertyName: "value", Value: "|" },
        { Id: 551015, PropertyName: "value", Value: "|" },
        { Id: 321188, PropertyName: "value", Value: "→" },
        { Id: 52788, PropertyName: "value", Value: "Proje İlerlemesi" },
        { Id: 490554, PropertyName: "tab", Value: "📋 Özet" },
        { Id: 370812, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 873090, PropertyName: "value", Value: "Kategori:" },
        { Id: 532359, PropertyName: "value", Value: "Güç:" },
        { Id: 488872, PropertyName: "value", Value: "Bütçe:" },
        { Id: 707335, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 652581, PropertyName: "value", Value: "MÜŞTERİ BİLGİLERİ" },
        { Id: 692080, PropertyName: "value", Value: "Müşteri:" },
        { Id: 756078, PropertyName: "value", Value: "İletişim:" },
        { Id: 300522, PropertyName: "value", Value: "Telefon:" },
        { Id: 695712, PropertyName: "value", Value: "E-posta:" },
        { Id: 47064, PropertyName: "value", Value: "ADRES" },
        { Id: 644014, PropertyName: "value", Value: "BİRİM İŞLEM DURUMLARI" },
        { Id: 518329, PropertyName: "value", Value: "Satış" },
        { Id: 550139, PropertyName: "value", Value: "/" },
        { Id: 531520, PropertyName: "value", Value: "Muhasebe" },
        { Id: 939493, PropertyName: "value", Value: "/" },
        { Id: 10258, PropertyName: "value", Value: "Proje" },
        { Id: 420784, PropertyName: "value", Value: "/" },
        { Id: 474956, PropertyName: "value", Value: "Satınalma" },
        { Id: 800931, PropertyName: "value", Value: "/" },
        { Id: 979930, PropertyName: "value", Value: "MTS" },
        { Id: 114456, PropertyName: "value", Value: "/" },
        { Id: 389472, PropertyName: "value", Value: "Depo" },
        { Id: 394017, PropertyName: "value", Value: "/" },
        { Id: 820460, PropertyName: "value", Value: "Pazarlama" },
        { Id: 331011, PropertyName: "value", Value: "/" },
        { Id: 30057, PropertyName: "value", Value: "Ariza" },
        { Id: 151825, PropertyName: "value", Value: "/" },
        { Id: 367991, PropertyName: "tab", Value: "🔍 Ön Süreç" },
        { Id: 656531, PropertyName: "value", Value: "Ön Keşif" },
        { Id: 796332, PropertyName: "value", Value: "Satış" },
        { Id: 814648, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 717071, PropertyName: "value", Value: "·" },
        { Id: 387411, PropertyName: "label", Value: "Görüntüle" },
        { Id: 620303, PropertyName: "value", Value: "Proforma Hazırlama" },
        { Id: 386387, PropertyName: "value", Value: "Satış" },
        {
          Id: 313289,
          PropertyName: "value",
          Value:
            "Müşteriye sunulacak proforma teklif hazırlandı ve PDF yüklendi.",
        },
        { Id: 57916, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 674947, PropertyName: "value", Value: "·" },
        { Id: 774399, PropertyName: "label", Value: "Görüntüle" },
        { Id: 74137, PropertyName: "value", Value: "Net Keşif" },
        { Id: 571228, PropertyName: "value", Value: "Proje Birimi" },
        {
          Id: 361937,
          PropertyName: "value",
          Value:
            "Müşteriye sunulacak proforma teklif hazırlandı ve PDF yüklendi.",
        },
        { Id: 555820, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 751342, PropertyName: "value", Value: "·" },
        { Id: 311100, PropertyName: "label", Value: "Görüntüle" },
        { Id: 157937, PropertyName: "value", Value: "Proje Yöneticisi Onayı" },
        { Id: 245671, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 278512,
          PropertyName: "value",
          Value:
            "Müşteriye sunulacak proforma teklif hazırlandı ve PDF yüklendi.",
        },
        { Id: 281820, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 42965, PropertyName: "value", Value: "·" },
        { Id: 565640, PropertyName: "label", Value: "Görüntüle" },
        { Id: 650582, PropertyName: "value", Value: "Üst Yönetim Onayı" },
        { Id: 741290, PropertyName: "value", Value: "Satış" },
        {
          Id: 815026,
          PropertyName: "value",
          Value:
            "PM onayı alındı. Üst yönetim onayı bekleniyor. Onaylanınca tüm birimler tetiklenecek.",
        },
        { Id: 831717, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 382963, PropertyName: "value", Value: "·" },
        { Id: 180592, PropertyName: "label", Value: "Görüntüle" },
        {
          Id: 823496,
          PropertyName: "value",
          Value: "Üst yönetim onayı verildiğinde",
        },
        {
          Id: 807533,
          PropertyName: "value",
          Value: "Satış, Muhasebe, MTS, Proje, Satınalma ve Pazarlama",
        },
        {
          Id: 264587,
          PropertyName: "value",
          Value:
            "birimlerine otomatik bildirim gidecek ve işlemler başlayacak.",
        },
        { Id: 832682, PropertyName: "tab", Value: "📌 Aşamalar" },
        { Id: 816640, PropertyName: "title", Value: "Title" },
        { Id: 196767, PropertyName: "value", Value: "[datafield:asamaadi]" },
        {
          Id: 41749,
          PropertyName: "value",
          Value: "[datafield:tamamlayanadi]",
        },
        { Id: 240537, PropertyName: "value", Value: "·" },
        {
          Id: 117789,
          PropertyName: "value",
          Value: "[datafield:tamamlanmatarihi]",
        },
        { Id: 951113, PropertyName: "value", Value: "%" },
        { Id: 705958, PropertyName: "value", Value: "[datafield:yuzde]" },
        { Id: 962033, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 899938, PropertyName: "tab", Value: "💼 Satış" },
        { Id: 442005, PropertyName: "tab", Value: "📊 Muhasebe" },
        { Id: 626472, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 481113, PropertyName: "value", Value: "Kategori:" },
        { Id: 704541, PropertyName: "value", Value: "Çatı GES - Öz Tüketim" },
        { Id: 733704, PropertyName: "value", Value: "Güç:" },
        { Id: 741508, PropertyName: "value", Value: "100 kWp" },
        { Id: 448136, PropertyName: "value", Value: "Bütçe:" },
        { Id: 126357, PropertyName: "value", Value: "₺850,000" },
        { Id: 275607, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 355158, PropertyName: "value", Value: "PRJ2026001" },
        { Id: 895510, PropertyName: "value", Value: "MÜŞTERİ BİLGİLERİ" },
        { Id: 760601, PropertyName: "value", Value: "Müşteri:" },
        { Id: 664254, PropertyName: "value", Value: "ABC Tekstil A.Ş." },
        { Id: 314114, PropertyName: "value", Value: "İletişim:" },
        { Id: 295506, PropertyName: "value", Value: "Mehmet Yılmaz" },
        { Id: 180244, PropertyName: "value", Value: "Telefon:" },
        { Id: 544535, PropertyName: "value", Value: "0532 123 45 67" },
        { Id: 818771, PropertyName: "value", Value: "E-posta:" },
        { Id: 405505, PropertyName: "value", Value: "m.yilmaz@abc.com" },
        { Id: 387266, PropertyName: "value", Value: "ADRES" },
        {
          Id: 657407,
          PropertyName: "value",
          Value: "Organize Sanayi Bölgesi 5. Cadde No:12, Karatay / Konya",
        },
        { Id: 434141, PropertyName: "value", Value: "BİRİM İŞLEM DURUMLARI" },
        { Id: 547881, PropertyName: "value", Value: "Satış" },
        { Id: 762535, PropertyName: "value", Value: "4/5" },
        { Id: 790249, PropertyName: "value", Value: "Muhasebe" },
        { Id: 77163, PropertyName: "value", Value: "4/5" },
        { Id: 373110, PropertyName: "value", Value: "Proje" },
        { Id: 851748, PropertyName: "value", Value: "4/5" },
        { Id: 663528, PropertyName: "value", Value: "Satınalma" },
        { Id: 103368, PropertyName: "value", Value: "4/5" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.projedetay_891482_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GET_PROJE_DETAY: [],
      GET_PROJE_BIRIM_DURUMLAR: [],
      GET_PROJE_ASAMALAR_DURUM: [],
      GET_PROJE_ON_SUREC: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("projedetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ProjeDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("projedetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("projedetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProjeDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  ProjeDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      ProjeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeDetay/ProjeDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_DETAY = result?.data.geT_PROJE_DETAY;
    formVars.projedetay_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeKodu
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeKodu
        : null
    );
    formVars.projedetay_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].kategoriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].kategoriAdi
        : null
    );
    formVars.projedetay_480115_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeTipi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeTipi
        : null
    );
    formVars.projedetay_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeAdi
        : null
    );
    formVars.projedetay_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].baslangicTarihi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].baslangicTarihi
        : null
    );
    formVars.projedetay_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].tahminiBitis
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].tahminiBitis
        : null
    );
    formVars.projedetay_413736_percent = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].ilerlemeYuzdesi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].ilerlemeYuzdesi
        : null
    );
    formVars.projedetay_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].kategoriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].kategoriAdi
        : null
    );
    formVars.projedetay_301417_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].gucKwp
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].gucKwp
        : null
    );
    formVars.projedetay_298959_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].butce
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].butce
        : null
    );
    formVars.projedetay_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].netsisProjKodu
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].netsisProjKodu
        : null
    );
    formVars.projedetay_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[stateVars.GET_PROJE_DETAY.length - 1]
              .iletisimKisi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[this.state.GET_PROJE_DETAY.length - 1]
            .iletisimKisi
        : null
    );
    formVars.projedetay_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].telefon
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].telefon
        : null
    );
    formVars.projedetay_750631_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].eposta
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].eposta
        : null
    );
    formVars.projedetay_346352_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].adres
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].adres
        : null
    );
    formVars.projedetay_852469_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_43310_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_500257_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    formVars.projedetay_204047_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );
    stateVars.GET_PROJE_BIRIM_DURUMLAR = result?.data.geT_PROJE_BIRIM_DURUMLAR;
    formVars.projedetay_755118_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
        : null
    );
    formVars.projedetay_476856_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Toplam
        : null
    );
    formVars.projedetay_369169_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Tamamlanan
        : null
    );
    formVars.projedetay_946524_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Toplam
        : null
    );
    formVars.projedetay_235644_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].proje_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].proje_Tamamlanan
        : null
    );
    formVars.projedetay_986115_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].proje_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].proje_Toplam
        : null
    );
    formVars.projedetay_373122_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[
              stateVars.GET_PROJE_BIRIM_DURUMLAR.length - 1
            ].satinalma_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[
            this.state.GET_PROJE_BIRIM_DURUMLAR.length - 1
          ].satinalma_Tamamlanan
        : null
    );
    formVars.projedetay_724803_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
        : null
    );
    formVars.projedetay_634450_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Tamamlanan
        : null
    );
    formVars.projedetay_898355_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Toplam
        : null
    );
    formVars.projedetay_268979_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].depo_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].depo_Tamamlanan
        : null
    );
    formVars.projedetay_769989_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].depo_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].depo_Toplam
        : null
    );
    formVars.projedetay_327184_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Tamamlanan
        : null
    );
    formVars.projedetay_745167_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Toplam
        : null
    );
    formVars.projedetay_995977_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Tamamlanan
        : null
    );
    formVars.projedetay_502678_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Toplam
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.projedetay_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeKodu
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeKodu
        : null
    );

    formVars.projedetay_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].kategoriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].kategoriAdi
        : null
    );

    formVars.projedetay_480115_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeTipi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeTipi
        : null
    );

    formVars.projedetay_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].projeAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].projeAdi
        : null
    );

    formVars.projedetay_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].baslangicTarihi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].baslangicTarihi
        : null
    );

    formVars.projedetay_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].tahminiBitis
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].tahminiBitis
        : null
    );

    formVars.projedetay_413736_percent = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].ilerlemeYuzdesi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].ilerlemeYuzdesi
        : null
    );

    formVars.projedetay_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].kategoriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].kategoriAdi
        : null
    );

    formVars.projedetay_301417_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].gucKwp
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].gucKwp
        : null
    );

    formVars.projedetay_298959_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].butce
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].butce
        : null
    );

    formVars.projedetay_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].netsisProjKodu
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].netsisProjKodu
        : null
    );

    formVars.projedetay_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[stateVars.GET_PROJE_DETAY.length - 1]
              .iletisimKisi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[this.state.GET_PROJE_DETAY.length - 1]
            .iletisimKisi
        : null
    );

    formVars.projedetay_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].telefon
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].telefon
        : null
    );

    formVars.projedetay_750631_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].eposta
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].eposta
        : null
    );

    formVars.projedetay_346352_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].adres
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].adres
        : null
    );

    formVars.projedetay_755118_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
        : null
    );

    formVars.projedetay_476856_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Toplam
        : null
    );

    formVars.projedetay_369169_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Tamamlanan
        : null
    );

    formVars.projedetay_946524_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].muhasebe_Toplam
        : null
    );

    formVars.projedetay_235644_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].proje_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].proje_Tamamlanan
        : null
    );

    formVars.projedetay_986115_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].proje_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].proje_Toplam
        : null
    );

    formVars.projedetay_373122_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[
              stateVars.GET_PROJE_BIRIM_DURUMLAR.length - 1
            ].satinalma_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[
            this.state.GET_PROJE_BIRIM_DURUMLAR.length - 1
          ].satinalma_Tamamlanan
        : null
    );

    formVars.projedetay_724803_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].satis_Tamamlanan
        : null
    );

    formVars.projedetay_634450_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Tamamlanan
        : null
    );

    formVars.projedetay_898355_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].mtS_Toplam
        : null
    );

    formVars.projedetay_268979_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].depo_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].depo_Tamamlanan
        : null
    );

    formVars.projedetay_769989_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].depo_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].depo_Toplam
        : null
    );

    formVars.projedetay_327184_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Tamamlanan
        : null
    );

    formVars.projedetay_745167_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].pazarlama_Toplam
        : null
    );

    formVars.projedetay_995977_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Tamamlanan
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Tamamlanan
        : null
    );

    formVars.projedetay_502678_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_BIRIM_DURUMLAR !== undefined
        ? stateVars.GET_PROJE_BIRIM_DURUMLAR?.length > 0
          ? stateVars.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Toplam
          : null
        : this.state.GET_PROJE_BIRIM_DURUMLAR?.length > 0
        ? this.state.GET_PROJE_BIRIM_DURUMLAR[0].ariza_Toplam
        : null
    );

    formVars.projedetay_852469_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_43310_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_500257_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    formVars.projedetay_204047_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_DETAY !== undefined
        ? stateVars.GET_PROJE_DETAY?.length > 0
          ? stateVars.GET_PROJE_DETAY[0].musteriAdi
          : null
        : this.state.GET_PROJE_DETAY?.length > 0
        ? this.state.GET_PROJE_DETAY[0].musteriAdi
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProjeDetayComponent_838016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeDetayComponent_261399_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeDetay/ProjeDetayComponent_261399_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_ASAMALAR_DURUM = result?.data.geT_PROJE_ASAMALAR_DURUM;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeDetayComponent_261399_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeDetayComponent_261399_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_891482 =
      stateVars.GET_PROJE_ASAMALAR_DURUM ?? this.state.GET_PROJE_ASAMALAR_DURUM;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeDetayComponent_367991_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeDetay/ProjeDetayComponent_367991_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_ON_SUREC = result?.data.geT_PROJE_ON_SUREC;
    formVars.projedetay_625172_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Notu
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Notu
        : null
    );
    formVars.projedetay_616113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Kullanici
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Kullanici
        : null
    );
    formVars.projedetay_132051_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Tarih
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Tarih
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeDetayComponent_367991_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeDetayComponent_367991_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.projedetay_625172_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Notu
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Notu
        : null
    );

    formVars.projedetay_616113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Kullanici
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Kullanici
        : null
    );

    formVars.projedetay_132051_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_PROJE_ON_SUREC !== undefined
        ? stateVars.GET_PROJE_ON_SUREC?.length > 0
          ? stateVars.GET_PROJE_ON_SUREC[0].onKesif_Tarih
          : null
        : this.state.GET_PROJE_ON_SUREC?.length > 0
        ? this.state.GET_PROJE_ON_SUREC[0].onKesif_Tarih
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProjeDetayPageInit();
    }
  }
}
